import React from 'react';
import ReactDOM from 'react-dom/client';
import Arch from './Arch';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Arch />
  </React.StrictMode>
);
